import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RepresentacaoEmpresa } from '../models/representacao-empresa.model';

@Injectable({
  providedIn: 'root'
})
export class RepresentacaoEmpresaService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all RepresentacaoEmpresa
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: RepresentacaoEmpresa[] }>(`${this.path}/getAllRepresentacaoEmpresa`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      map(response => response)
    );
  }

  // Get RepresentacaoEmpresa by ID
  public show(id: string): Observable<RepresentacaoEmpresa> {
    return this.apiService.get<{ data: RepresentacaoEmpresa }>(`${this.path}/getRepresentacaoEmpresaById/${id}`).pipe(
      map(response => response.data)
    );
  }

  // Create new RepresentacaoEmpresa
  public store(representacaoEmpresa: RepresentacaoEmpresa): Observable<RepresentacaoEmpresa> {
    return this.apiService
      .post<{ object: RepresentacaoEmpresa }>(`${this.path}/AddRepresentacaoEmpresa`, representacaoEmpresa)
      .pipe(
        map(response => response.object)
      );
  }

  // Update existing RepresentacaoEmpresa
  public update(representacaoEmpresa: RepresentacaoEmpresa, id: string): Observable<RepresentacaoEmpresa> {
    return this.apiService
      .put<{ object: RepresentacaoEmpresa }>(`${this.path}/UpdateRepresentacaoEmpresa/${id}`, representacaoEmpresa)
      .pipe(
        map(response => response.object)
      );
  }

  // Delete existing RepresentacaoEmpresa
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteRepresentacaoEmpresaById/${id}`);
  }
}
